// Externalized game/machine config loader.
// Merges: base defaults ← env ← caller overrides. Kiosk builds layer a local
// machine config on top later (handled by the Machine Service host).

function envGet(key) {
  try {
    if (typeof process !== 'undefined' && process.env && process.env[key]) return process.env[key];
  } catch (_e) { /* ignore */ }
  return undefined;
}

export function loadGameConfig({
  gameId,
  gameVersion,
  gameSlug,
  denominations,
  betOptions,
  overrides,
} = {}) {
  const apiBase = (envGet('REACT_APP_BACKEND_URL') || '') + '/api';

  const base = {
    gameId: gameId || 'unknown',
    gameVersion: gameVersion || '1.0.0',
    gameSlug: gameSlug || gameId || 'unknown',
    environment: envGet('NODE_ENV') || 'development',
    machineId: envGet('REACT_APP_MACHINE_ID') || null,
    endpoints: { apiBase },
    denominations: denominations || [],
    betOptions: betOptions || [],
    orientation: 'responsive', // kiosk overrides to 'landscape' | 'portrait'
    featureFlags: {},
  };

  return { ...base, ...(overrides || {}) };
}
